<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>
    <section class="bg-home bg-circle-gradiant d-flex align-items-center">
      <div class="bg-overlay bg-overlay-white"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-8">
            <div class="card login_page shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center">
                  {{ $t("auth:forgot_password.text") }}
                </h4>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    class="login-form mt-4"
                    @submit.prevent="handleSubmit(forgotPassword)"
                  >
                    <div class="row">
                      <div class="col-lg-12">
                        <p class="text-muted">
                          {{ $t("auth:forgot_password.description") }}
                        </p>
                        <div class="form-group">
                          <ValidationProvider
                            name="username"
                            rules="required|alpha_num|max:30|min:4"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:forgot_password.labels.username") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <user-icon class="fea icon-sm icons"></user-icon>
                              <input
                                v-model="user.username"
                                type="text"
                                class="form-control pl-5"
                                :placeholder="
                                  $t('auth:forgot_password.labels.username')
                                "
                                name="username"
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': msg.length > 0 },
                                  { 'is-invalid': failed }
                                ]"
                              />
                              <span
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(errors[0]) }}</span
                              >
                              <span
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(msg) }}</span
                              >
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <button class="btn btn-primary btn-block">
                          {{ $t("auth:forgot_password.send") }}
                        </button>
                      </div>

                      <div class="mx-auto">
                        <p class="mb-0 mt-3">
                          <small class="text-dark mr-2">{{
                            $t("auth:forgot_password.remember_password")
                          }}</small>
                          <router-link
                            to="/login"
                            class="text-dark font-weight-bold"
                            >{{
                              $t("auth:forgot_password.sign_in")
                            }}</router-link
                          >
                        </p>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { HomeIcon, UserIcon } from "vue-feather-icons";
import HttpClientFactory from "../services/HttpClientFactory";

export default {
  name: "ForgotPassword",
  components: {
    HomeIcon,
    UserIcon
  },
  data() {
    return {
      user: {
        username: ""
      },
      msg: ""
    };
  },
  methods: {
    forgotPassword() {
      this.httpClient = HttpClientFactory.getInstance();
      const sendData = {
        username: this.user.username
      };
      this.httpClient
        .post(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/forgot-password",
          sendData
        )
        .then(() => {
          this.$notify({
            text: this.$t("auth:forgot_password.send_email"),
            type: "success"
          });
        })
        .catch(() => {
          this.msg = "auth:forgot_password.error_found";
        });
    }
  }
};
</script>
